import { generateArrayOfYears } from 'utils'

export const GIORNI = Array.from({ length: 31 }, (_, i) => i + 1)

export const MESI = Array.from({ length: 12 }, (_, i) => i + 1)

export const ANNI = generateArrayOfYears()
